import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import { useThemeValue } from '../system';

function Path(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      restProps = _objectWithoutPropertiesLoose(_ref, ["name", "color"]);

  var pathData = useThemeValue(['icons'].concat(name.split('.')));
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "path",
    d: pathData,
    fill: color
  }, restProps));
}

export default Path;